module.exports = __webpack_public_path__ + "overview-a5b6df21/icon-fencing-547ff31a6ed994286a90470b77bf1351.png";